import { lazy, Suspense, useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastProvider } from './contexts/ToastContext';
import { ToastContext } from './contexts/ToastContext';
import { LoadingSpinner } from './components/LoadingSpinner';

// Eager-loaded components (needed immediately on app load)
import SignIn from './SignIn';
import SignUp from './SignUp';
import PasswordReset from './PasswordReset';
import RootRedirect from './RootRedirect';
import ToastContainer from './components/ToastContainer';

// Lazy-loaded components (loaded on-demand when route is accessed)
// This splits your 1.6MB bundle into smaller chunks for faster initial load
const Layout = lazy(() => import('./Layout'));
const ProtectedRoute = lazy(() => import('./ProtectedRoute'));
const AlbumPage = lazy(() => import('./AlbumPage'));
const CMS = lazy(() => import('./CMS'));
const Albums = lazy(() => import('./Albums'));
const AlbumsConfiguration = lazy(() => import('./AlbumsConfiguration'));
const VideosConfiguration = lazy(() => import('./VideosConfiguration'));
const MyAccount = lazy(() => import('./MyAccount'));
const Friends = lazy(() => import('./Friends'));

function ToastContainerWrapper() {
  const context = useContext(ToastContext);
  if (!context) return null;
  return <ToastContainer toasts={context.toasts} onRemove={context.removeToast} />;
}

export default function App() {
  return (
    <ToastProvider>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/passwordreset" element={<PasswordReset />} />

          {/* Public album routes - accessible to guests */}
          <Route element={<Layout />}>
            <Route path="/albums/:slug" element={<AlbumPage />} />
            <Route path="/albums/:slug/:videoSlug" element={<AlbumPage />} />
          </Route>

          {/* Protected routes - require authentication */}
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/cms" element={<CMS />} />
              <Route path="/submembers" element={<Friends />} />
              <Route path="/albums" element={<Albums />} />
              <Route path="/albums-config" element={<AlbumsConfiguration />} />
              <Route path="/videos-config" element={<VideosConfiguration />} />
              <Route path="/my-account" element={<MyAccount />} />
            </Route>
          </Route>
        </Routes>
      </Suspense>
      <ToastContainerWrapper />
    </ToastProvider>
  );
}

